<template>
  <CancelFlowRedesignExperiment>
    <template #default>
      <PausePage/>
    </template>
    <template #redesign>
      <PauseRedesign/>
    </template>
  </CancelFlowRedesignExperiment>
</template>
<script setup>
import CancelFlowRedesignExperiment from '@/components/account/membership/new/CancelFlowRedesignExperiment.vue'
import PausePage from '@/components/account/membership/PausePage.vue'
import PauseRedesign from '@/views/account/PausePage.vue'
</script>
